import { useMutation, useQueryClient } from 'react-query';
import { useContext } from 'react';
import { FetchContext } from 'context/FetchContext';

function useDeleteStream() {
  const { privateFetch } = useContext(FetchContext);
  const queryClient = useQueryClient();

  return useMutation((data) => privateFetch.delete(`/v1/admin/streams/${data._id || data.id}`), {
    onSuccess: () => {
      queryClient.invalidateQueries('streams-list');
    },
  });
}

export default useDeleteStream;
